import type { RestrictedWord } from "@/shared/cache/slices/restrictedWords";
import type { Entry } from "@/shared/types/entries";
import { DateBar } from "@/v2/components/DateBar";
import { FilterPopover, type FilterState } from "@/v2/components/FilterPopover";
import {
	type GroupMode,
	type SortMode,
	SortPopover,
} from "@/v2/components/SortPopover";
import type { DateRange } from "@/v2/hooks/useDateParams";

export interface EntriesDateToolbarProps {
	date: Date;
	dateRange: DateRange;
	onDateChange: (date: Date) => void;
	onDateRangeChange: (dateRange: DateRange) => void;
	filter: FilterState;
	onFilterChange: (filter: FilterState) => void;
	sort: SortMode;
	group: GroupMode;
	onSortChange: (sort: SortMode) => void;
	onGroupChange: (group: GroupMode) => void;
	entries: Entry[];
	getRestrictedWords?: (client?: string, matter?: string) => RestrictedWord[];
	timekeeperSlot?: React.ReactNode;
}

export function EntriesDateToolbar({
	date,
	dateRange,
	onDateChange,
	onDateRangeChange,
	filter,
	onFilterChange,
	sort,
	group,
	onSortChange,
	onGroupChange,
	entries,
	getRestrictedWords,
	timekeeperSlot,
}: EntriesDateToolbarProps) {
	return (
		<div className="sticky top-0 z-20 border-b border-border bg-background">
			<DateBar
				date={date}
				dateRange={dateRange}
				onDateChange={onDateChange}
				onDateRangeChange={onDateRangeChange}
				leftSlot={
					<div className="flex items-center">
						<FilterPopover
							filter={filter}
							onChange={onFilterChange}
							entries={entries}
							getRestrictedWords={getRestrictedWords}
						/>
						{timekeeperSlot}
					</div>
				}
				rightSlot={
					<SortPopover
						sort={sort}
						group={group}
						onSortChange={onSortChange}
						onGroupChange={onGroupChange}
					/>
				}
			/>
		</div>
	);
}
